import type { IconNames } from '@workramp/ui';
import type { AssetType, ReportType } from '~/types';
import { useTheme } from 'styled-components';
import { Icon, Stack, usePress } from '@workramp/ui';
import { ContentIcon } from '~/features/common';
import { ICON_MAP } from '~/constants';
import { colorFromAssetType } from './util';
import { IconTextPairWrapper, IconWrapper, Text } from './StyledIconTextPair.styles';

export interface StyledIconTextPairProps {
  type?: AssetType | ReportType;
  icon: string;
  text: string;
  subtext?: string;
  href?: string;
  isActive?: boolean;
  isHidden?: boolean;
  onPress?: () => void;
}

const StyledIconTextPair = ({
  type,
  icon,
  text,
  subtext,
  href = null,
  isActive = false,
  isHidden = false,
  onPress,
}: StyledIconTextPairProps) => {
  const theme = useTheme();
  let { pressProps } = usePress({ onPress });

  if (!onPress) {
    pressProps = {};
  }

  const color = colorFromAssetType(icon);
  const iconColor = color ? theme.colors.decorative[color][500] : theme.colors.secondary[500];

  const contentIconExists = !!ICON_MAP[type];

  return (
    <IconTextPairWrapper
      as={href ? 'a' : 'div'}
      className="asset-picker-asset--label-text"
      $selected={isActive}
      href={href}
      {...pressProps}
    >
      <IconWrapper>
        {isHidden ? (
          <Icon name="eye-close:regular" color={theme.colors.on[600]} />
        ) : (
          <>
            {contentIconExists && <ContentIcon type={type} />}{' '}
            {/* TODO: Refactor https://workramp.atlassian.net/browse/PAR-396 */}
            {!contentIconExists && <Icon name={`${icon}:regular` as IconNames} color={iconColor} />}
          </>
        )}
      </IconWrapper>
      <Stack size={0}>
        <Text isExpandable maxLines={1} size={1} density="lg" {...pressProps}>
          {text}
        </Text>
        {subtext && (
          <Text color={theme.colors.on[500]} isExpandable maxLines={1} size={0} density="lg" {...pressProps}>
            {subtext}
          </Text>
        )}
      </Stack>
    </IconTextPairWrapper>
  );
};

export default StyledIconTextPair;
